import { Fragment } from "react";
import Footer from "./Footer";
import Composite from "./CompositeItem";
import Message from "./Message";
import Separator from "components/shared/Separator";
import { arrayIsEmpty, objectIsEmpty } from "utils";
import { txpMotionDelayMs, txpMotionClasses } from "config-txp";

const Full = ({
	brand,
	message,
	compositeItems,
	standaloneItems,
	standaloneItemsTitle,
	currencyChangeDetail,
	price,
	buttons,
	startOver,
	emptyCart,
	totalNumberOfItems,
	additionalItemsText,
	isTxp = false,
	isHovering,
}) => {
	const totalItems =
		(compositeItems?.length ?? 0) + (standaloneItems?.length ?? 0);

	const maxItems = 4;
	const animationClasses = isTxp
		? isHovering
			? txpMotionClasses.motionFadeIn
			: txpMotionClasses.motionFadeOut
		: "";

	return (
		<Fragment>
			{!objectIsEmpty(message) && (
				<div>
					<Message {...message} isTxp={isTxp} />
					{isTxp && <Separator />}
				</div>
			)}
			{!arrayIsEmpty(compositeItems) &&
				compositeItems.map((item, key) => (
					<Fragment key={key}>
						{!isTxp && <Separator />}
						<Composite
							title={item.title}
							category={item.category}
							items={item.items}
							separateTitle={false}
							separateItems={item?.separateItems}
							isTxp={isTxp}
							animationClasses={animationClasses}
						/>
						<Separator />
					</Fragment>
				))}
			{!arrayIsEmpty(standaloneItems) && (
				<Composite
					title={standaloneItemsTitle}
					category="standalone"
					items={standaloneItems}
					separateItems={true}
					isTxp={isTxp}
					animationClasses={animationClasses}
				/>
			)}
			{totalNumberOfItems > maxItems ? (
				<Message
					content={additionalItemsText}
					animationClasses={animationClasses}
					containerStyle={{
						animationDelay: `${txpMotionDelayMs.tiny}ms`,
					}}
				/>
			) : null}
			{(!arrayIsEmpty(compositeItems) || !arrayIsEmpty(standaloneItems)) && (
				<Footer
					brand={brand}
					price={price}
					showLink={objectIsEmpty(message)}
					buttons={buttons}
					currencyChangeDetail={currencyChangeDetail}
					startOver={startOver}
					emptyCart={emptyCart}
					isTxp={isTxp}
					animationClasses={animationClasses}
					totalItems={totalItems}
				/>
			)}
		</Fragment>
	);
};

export default Full;
